// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#overlay {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 3;
}

#qrImageModal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
}
#qrImageModal ::ng-deep .qrcode {
  height: 100%;
  padding: 30px;
}
#qrImageModal ::ng-deep .qrcode img {
  display: block;
  margin: auto;
  max-width: 100%;
  max-height: 100%;
}

.qrimgcode ::ng-deep div img {
  width: 150px;
  height: auto;
}

.close {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 45px;
  transition: 0.3s;
  color: #b4bdce;
}

.close:hover,
.close:focus {
  cursor: pointer;
  color: #7987a1;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/enrollment/enrollment.component.scss"],"names":[],"mappings":"AAUA;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,UAAA;AATF;;AAaA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAVF;AAWE;EACE,YAAA;EACA,aAAA;AATJ;AAWI;EACI,cAAA;EACF,YAAA;EACA,eAAA;EACA,gBAAA;AATN;;AAiBM;EACE,YAAA;EACA,YAAA;AAdR;;AAoBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cA1D8B;AAyChC;;AAoBA;;EAEE,eAAA;EACA,cA9D8B;AA6ChC","sourcesContent":["$gray-100:                      #f4f5f8;\n$gray-200:                      #e3e7ed;\n$gray-300:                      #cdd4e0;\n$gray-400:                      #b4bdce;\n$gray-500:                      #97a3b9;\n$gray-600:                      #7987a1;\n$gray-700:                      #596882;\n$gray-800:                      #3b4863;\n$gray-900:                      #1c273c;\n\n#overlay {\n  position: fixed;\n  display: none;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgb(0,0,0,.7);\n  z-index: 3;\n}\n\n\n#qrImageModal{\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 4;\n  ::ng-deep .qrcode {\n    height: 100%;\n    padding: 30px;\n\n    img {\n        display: block;\n      margin: auto;\n      max-width: 100%;\n      max-height: 100%;\n    }\n  }\n}\n\n.qrimgcode {\n  ::ng-deep {\n    div {\n      img {\n        width: 150px;\n        height: auto;\n      }\n    }\n  }\n}\n\n.close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  font-size: 45px;\n  transition: 0.3s;\n  color: $gray-400;\n}\n\n.close:hover,\n.close:focus {\n  cursor: pointer;\n  color: $gray-600;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
